﻿import { Component } from "@angular/core";

@Component({
    selector: "itp-spinner",
    templateUrl: "./layout-spinner.component.html"
})
export class LayoutSpinnerComponent {
}